// extracted by mini-css-extract-plugin
module.exports = {"icon":"NotWarranty_icon__h4NJK"};